class ProductCountdown extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const specificDate = this.getAttribute('data-end-date');
    const countDownDate = specificDate ? new Date(specificDate) : this.getMonthEnd(new Date());
    
    // Convert to CEST for comparison
    const cestOffset = 2; // CEST is UTC+2
    const now = new Date();
    const cestNow = new Date(now.getTime() + (now.getTimezoneOffset() * 60000) + (cestOffset * 3600000));
    
    // Don't initialize countdown if end date is in the past
    if (countDownDate.getTime() <= cestNow.getTime()) {
      this.remove();
      return;
    }

    setInterval(() => {
      const base = "0";
      const currentCEST = new Date(Date.now() + (now.getTimezoneOffset() * 60000) + (cestOffset * 3600000));
      const distance = countDownDate.getTime() - currentCEST.getTime();

      // Time calculations for days, hours, minutes and seconds
      const days = Math.max(0, Math.floor(distance / (1000 * 60 * 60 * 24)));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      const element = document.getElementById("countdown");
      if (!element) return;

      element.querySelector("[data-day]").innerHTML = days < 10 ? base.concat(days) : days;
      element.querySelector("[data-hour]").innerHTML = hours < 10 ? base.concat(hours) : hours;
      element.querySelector("[data-minute]").innerHTML = minutes < 10 ? base.concat(minutes) : minutes;
      element.querySelector("[data-second]").innerHTML = seconds < 10 ? base.concat(seconds) : seconds;

      // Remove countdown if time is up
      if (distance < 0) {
        this.remove();
      }
    }, 1000);
  }

  getMonthEnd(date = new Date()) {
    const dateCopy = new Date(date.getTime());
    dateCopy.setMonth(dateCopy.getMonth() + 1, 1);
    dateCopy.setDate(dateCopy.getDate() - 1);
    dateCopy.setHours(23, 59, 59, 999);
    return dateCopy;
  }
}
customElements.define("product-countdown", ProductCountdown);
